<div class="modal-header" style="display:flex;">
    <h3 class="modal-title">Manage Mileage Rates</h3>
    <span *ngIf="lastSave.status == 'success' && lastSave.time != null" class="badge badge-success" [ngClass]="{fade: labelFade}">Save Successful - {{lastSave.time}}</span>
    <span *ngIf="lastSave.status != 'success' && lastSave.time != null" class="badge badge-danger" [ngClass]="{fade: labelFade}">Save Fail - {{lastSave.time}}</span>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-2">
            <label><strong>PRCo</strong></label>
            <input type="number" class="form-control" [(ngModel)]="formData.newPRCo" style="resize:none" />
        </div>
        <div class="col-md-3">
            <label><strong>Mileage Rate</strong></label>
            <input type="text" class="form-control" [(ngModel)]="formData.newRate" style="resize:none" />
        </div>
        <div class="col-md-3">
            <label><strong>Rate Description</strong></label>
            <input type="text" class="form-control" [(ngModel)]="formData.newDescription" style="resize:none" />
        </div>
        <div class="col-md-4">
            <button type="button" class="btn btn-success buttonNoLabel" (click)="addEditCat()"
                    [disabled]="formData.newPRCo == null || formData.newPRCo == '' || formData.newRate == null || formData.newRate == '' || formData.newDescription == null || formData.newDescription == ''">
                Add
            </button>
        </div>
    </div>
    <hr />
    <div *ngIf="rateList?.length < 1">Please add a mileage rate from the top.</div>
    <table class="table" *ngIf="rateList?.length > 0">
        <thead>
            <tr>
                <th class="col-md-2">
                    <div style="margin-bottom:5px;">PRCo</div>
                </th>
                <th class="col-md-3">
                    <div style="margin-bottom:5px;">Mileage Rate</div>
                </th>
                <th class="col-md-3">
                    <div style="margin-bottom:5px;">Rate Description</div>
                </th>
                <th class="col-md-4">
                    <div style="margin-bottom:5px;"></div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of rateList; let i = index">
                <td class="col-md-2">
                    <div style="margin-bottom:5px;">
                        <input type="text" class="form-control" [(ngModel)]="data.PRCo" (blur)="addEditCat(data)" />
                    </div>
                </td>
                <td class="col-md-3">
                    <div style="margin-bottom:5px;">
                        <input type="text" class="form-control" [(ngModel)]="data.MileageRate"
                               (blur)="addEditCat(data)" />
                    </div>
                </td>
                <td class="col-md-3">
                    <div style="margin-bottom:5px;">
                        <input type="text" class="form-control" [(ngModel)]="data.RateDescription"
                               (blur)="addEditCat(data)" />
                    </div>
                </td>
                <td class="col-md-4">
                    <div style="margin-bottom:5px;" *ngIf="data.deleteTrigger">
                        <button type="button" class="btn btn-outline-dark"
                                (click)="deleteTrigger(data, 'no')">
                            Cancel
                        </button>
                        <button type="button" class="btn btn-danger" (click)="deleteCat(data)">Delete</button>
                    </div>
                    <div style="margin-bottom:5px;" *ngIf="!data.deleteTrigger">
                        <button type="button" class="btn btn-danger btn-icon-only" (click)="deleteTrigger(data, 'yes')">
                            <i class="modus-icons" aria-hidden="true">trash</i>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>